/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : notification.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */

import actionType from "../actionTypes";

const notificationsAction = {
  get_recent_notifications: {
    api_name: "/UCM/notifications/recent",
    https_method: "GET",
    action_type: actionType.GET_RECENT_NOTIFICATIONS,
    description: "",
  },
  get_all_notifications: {
    api_name: "/UCM/notifications/all",
    https_method: "GET",
    action_type: actionType.GET_ALL_NOTIFICATIFICATIONS,
    description: "",
  },
  mark_read_notifications: {
    api_name: "/UCM/notifications/mark-read",
    https_method: "PUT",
    action_type: actionType.NOTIFICATIONS_MARK_READ,
    description: "",
  },
  delete_notification_from_queue: {
    api_name: "/NSM/v1/notifications/deleteFromQueue",
    https_method: "PUT",
    action_type: actionType.DELETE_NOTIFICATION_FROM_QUEUE,
    description: "",
  },
};

export default notificationsAction;
